import { useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { CSVLink } from "react-csv";


const IncomingData = [
  {
    td1: "INV-3000",
    td2: "Adidas",
    td3: `Shoes`,
    td4: "Sneaker",
    td5: "2999",
    td6: "2",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-1111",
    td2: "Adidas",
    td3: `Shoes`,
    td4: "Sneaker",
    td5: "2999",
    td6: "2",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Adidas",
    td3: `Shoes`,
    td4: "Sneaker",
    td5: "2999",
    td6: "2",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-5555",
    td2: "Adidas",
    td3: `Shoes`,
    td4: "Sneaker",
    td5: "2999",
    td6: "2",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Adidas",
    td3: `Fashion`,
    td4: "Sneaker",
    td5: "2999",
    td6: "1",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Adidas",
    td3: `Electronics`,
    td4: "Sneaker",
    td5: "2999",
    td6: "4",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Adidas",
    td3: `Grocery`,
    td4: "Sneaker",
    td5: "2999",
    td6: "3",
    td7: "10.02.2023",
    td8: "Gurgaon",
    td9: "VIEW DETAILS",
  },
];

const InventoryTable1 = () => {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.td6.toString() === e.target.value));
  };


  return (
    <div id="OMS-main-content">
      <div className="order-list-box" >
        <div className="table_heading">
          <h4>SUPPLIER</h4>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
        <div id="click-data">
          <p>All Supplier</p>
          {/* <p>Supplier by location</p> */}
          
        </div>
        <div className="order-list-input-box">
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by invoice ID, category"
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.td1.match(val.target.value) || x.td3.match(val.target.value)
                  )
                );
                setFiltr1("");
              }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr1}
              onChange={handleFilter1}
            >
              <option value="" selected>
                Quantity
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
            {/* <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
            >
              <option selected>Order Status</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select> */}
            <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
          </div>
        </div>
        <table style={{ textAlign: "center" }}>
          <tr>
            <th>Supplier ID</th>
            <th>Brand name</th>
            <th>Category</th>
            <th>Sub-Category</th>
            <th>Worth</th>
            <th>Quantity</th>
            <th>Last Deal</th>
            <th>Location</th>
            <th>Details</th>
          </tr>
          {count.length > 0
            ? count.map((val) => {
                return (
                  <tr style={{lineHeight:"2rem"}}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td>{val.td4}</td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })
            : IncomingData.map((val) => {
                return (
                  <tr style={{ lineHeight: "2rem" }}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td className="">
                      {val.td4}
                    </td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })}
        </table>
      </div>
    </div>
  );
};

export default InventoryTable1;
